module.exports = __webpack_public_path__ + "img/tooltip-info.ec7357b6.svg";